import React from 'react';
import AdaptiveNavigation from './AdaptiveNavigation';

export default function BottomNavBar({ showCaregiverPages = true }) {
    return <AdaptiveNavigation bottom showCaregiverPages={showCaregiverPages} />;
}
